import { EntityId, EntityState, createEntityAdapter } from "@reduxjs/toolkit";

import { Dossier } from "types/Dossier";
import { UserPlayMode } from "../types/UserPlayMode";
import { PersistedRecording } from "types/PersistedRecording";

export const persistedRecordingAdapter =
    createEntityAdapter<PersistedRecording>({
        sortComparer: (a, b) =>
            a.persistedStartTime.localeCompare(b.persistedStartTime),
    });

export interface CaseViewerState {
    dossier?: Dossier;
    isLoadingDossier?: boolean;
    errorLoadingDossier?: string;

    persistedRecordings: EntityState<PersistedRecording, EntityId>;

    userRequestedPlayMode: UserPlayMode;

    playbackSpeed: number;
    playbackStartDateTime?: string;
    playbackElapsedTimeInMs: number;
    playbackStartDateTimeChangedTimestamp?: number;

    bufferWindowInSeconds: number;

    // keep track of the video files used for playing forwards
    persistedRecordingsReadyForPlayback: EntityId[];
    persistedRecordingsFailedToLoad: EntityId[];
    persistedRecordingsWaiting: EntityId[];

    // keep track of the video files used for reverse playback
    reversedPersistedRecordingsReadyForPlayback: EntityId[];
    reversedPersistedRecordingsFailedToLoad: EntityId[];
    reversedPersistedRecordingsWaiting: EntityId[];

    visibleDossierDeviceIds: EntityId[];
    fullscreenDossierDeviceId?: EntityId | undefined;

    // debug
    debugShowStatistics?: boolean;
    debugShowBufferingRecordings?: boolean;
    debugShowRecordingsOutsidePlaybackAndBufferingWindow?: boolean;
    debugShowForwardAndReversedRecordings?: boolean;
    debugShowSystemControls?: boolean;
    debugShowVideoDirectionInformation?: boolean;
}

export const initialState: CaseViewerState = {
    persistedRecordings: persistedRecordingAdapter.getInitialState(),
    playbackSpeed: 1,
    userRequestedPlayMode: "stop",

    playbackElapsedTimeInMs: 0,

    bufferWindowInSeconds: 30,

    persistedRecordingsReadyForPlayback: [],
    persistedRecordingsFailedToLoad: [],
    persistedRecordingsWaiting: [],

    reversedPersistedRecordingsReadyForPlayback: [],
    reversedPersistedRecordingsFailedToLoad: [],
    reversedPersistedRecordingsWaiting: [],

    visibleDossierDeviceIds: [],
    fullscreenDossierDeviceId: undefined,
};
